// Section Imports
import AboutSection from "./AboutSection";
import FeaturedSection from "./FeaturedSection";
import HeroSection from "./HeroSection";
import OrderCardSection from "./OrderCardSection";
import OurCollection from "./OurCollection";
import OurStorySection from "./OurStorySection";
import TestimonialSection from "./TestimonialSection";

const HomePage = () => {
  return (
    <div className=" text-zinc-700 ">
      <HeroSection />
      <OurStorySection />
      <FeaturedSection />
      <OurCollection />
      <AboutSection />
      <TestimonialSection />
      <OrderCardSection />
    </div>
  );
};

export default HomePage;
